import { render, staticRenderFns } from "./PaymentInstore_m.vue?vue&type=template&id=6a218a55&scoped=true&"
import script from "./PaymentInstore_m.vue?vue&type=script&lang=js&"
export * from "./PaymentInstore_m.vue?vue&type=script&lang=js&"
import style0 from "./PaymentInstore_m.vue?vue&type=style&index=0&id=6a218a55&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a218a55",
  null
  
)

export default component.exports